import { Box, Container } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { GangHeader } from '@operations/features/gang/components/molecules/GangHeader'
import { GangTable } from '@operations/features/gang/components/organisms/GangTable'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

export const GangPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()

    const { gangStore } = useOperationsStore()

    useAsyncFetch(async () => {
      await gangStore.fetchData()
    }, [gangStore])

    return (
      <Box
        sx={{
          bgcolor: theme.palette.grey[100],
          minHeight: '100%',
        }}
      >
        <GangHeader />
        <Container
          maxWidth='lg'
          sx={{ padding: theme.customSpacing.m }}
          data-cy='operational-equipment-table'
        >
          <GangTable gangStore={gangStore} />
        </Container>
      </Box>
    )
  }),
)
